export default __webpack_public_path__ + "static/media/visit.dc5826a3.svg";